import { memo } from "react";

import { QuestionAddress } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/address";

import { useRoomI18nAddress } from "./hooks";

export const QuestionRoomAddress = memo(() => {
	const { onSetCity, onSetPref, onSetTown, onSetPostalCode, address, isEdited, hasError } = useRoomI18nAddress();

	return (
		<QuestionAddress
			isEdited={isEdited}
			hasError={hasError}
			address={address}
			onSetPref={onSetPref}
			onSetCity={onSetCity}
			onSetTown={onSetTown}
			onSetPostalCode={onSetPostalCode}
		/>
	);
});

QuestionRoomAddress.displayName = "QuestionRoomAddress";
